export default "__VITE_ASSET__uWoYZz5f__"